import React, { useState } from 'react';

import Button from 'components/Button';
import { useAppLanguage } from 'hooks';
import appUrls from 'helpers/app-urls';

import { SSOAuthProviderKey } from 'entities/sso';
import { LoginMethodOption } from 'pages/Profile/ProfileLoginMethod';

// import messages from 'pages/Profile/messages';
import Modal from 'components/Modal';
import { useHistory } from 'react-router-dom';
import messages from './messages';

const imgUser = `${appUrls?.getCDNUrl()}/assets/auth/feature-icon-user.png`;

interface LoginMismatchModalProps {
  signinMethod: SSOAuthProviderKey;
  show: boolean;
  onClose: Function;
}

const LoginMismatchModal: React.FC<LoginMismatchModalProps> = ({
  signinMethod,
  show,
  onClose,
}) => {
  // #region HOOKS
  const language = useAppLanguage();
  const history = useHistory();
  // #endregion

  // #region TRANSLATIONS
  const viewMessages = messages[language].loginMismatch;
  // #endregion

  // #region STATE
  const [, setShowModal] = useState<boolean>(false);
  // #endregion

  // #region MISC
  const loginMethods: LoginMethodOption[] = [
    {
      key: 'EMAIL',
      name: viewMessages.email,
    },
    {
      key: 'GOOGLE',
      name: viewMessages.google,
    },
    {
      key: 'APPLE',
      name: viewMessages.apple,
    },
  ];

  const selectedMethod = loginMethods.find(
    (lm: LoginMethodOption) => lm.key === signinMethod,
  );
  // #endregion

  return (
    <Modal
      show={show}
      hasBlurredBackground
      closeModal={onClose}
      content={
        <div className="text-center">
          <div className="text-header-text text-2xl">{viewMessages.title}</div>
          <img
            src={imgUser}
            alt={`login-method-${selectedMethod?.key}`}
            className="w-32 mx-auto"
          />
          <div
            dangerouslySetInnerHTML={{
              __html: viewMessages.description(selectedMethod?.name as string),
            }}
          />
          <div className="flex flex-col items-center justify-center">
            <Button
              className="w-2/3 my-2"
              onClick={() => history.push('/profile/login-method')}
            >
              {viewMessages.submitText}
            </Button>
            <Button
              className="w-2/3"
              outlined
              onClick={() => setShowModal(false)}
            >
              {viewMessages.secondaryText}
            </Button>
          </div>
        </div>
      }
      hideModal={onClose}
    />
  );
};

export default LoginMismatchModal;
